<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.settings.ftps') }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    {{ ftpsHost }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ftpsHost: {
            type: String,
            required: true
        }
    }
};
</script>
